export const aboutContent = {
  mainParagraph1: `Jesteśmy firmą budowlaną, która specjalizuje się z robotach ziemnych, 
                   przygotowywaniem terenu pod prace drogowe, etc. Wyposażeni jesteśmy w ciężki 
                   sprzęt budowlany - koparki, koparko-ładowarki, spycharki, samochody ciężarowe.`,
  mainParagraph2: "Nasi główni kontrahenci oraz firmy wspólpracujące - Budimex S.A., REM-BUD Suwałki.",
};

export const servicesContent = {
  card1:
    "Specjalizujemy się w budowach dróg, przygotowaniem terenu pod budowę dróg. Głowne prace wykonawcze przy budowie, przepustów, rowów melioracyjnych, itp.",
  card2:
    "Prowadzimy roboty budowlane związane ze wznoszeniem budynków mieszkalnych i niemieszkalnych. Zajmujemy się rozbiórką i burzeniem obiektów budowlanych.",
  card3:
    "W zakresie naszych kompetencji mamy również usługi transportowe. Posiadami samochody ciężarowe do przewozu gruntu.",
};

export const financingContent = {
  text1: "Dofinansowanie",
};
